export default "__VITE_ASSET__b50be525__"